// src/util/weishop/Region.js
import axios from 'axios'

const REGION_TREE = 'region_tree'

/**
 * 地区模型类
 * RegionModel
 */
export default {
  getTreeDataFromApi() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/weishop/admin/region/tree')
        .then(result => {
          //console.log('Region API Response:', result.data) // 调试日志
          let data = result.data
          // 处理 API 返回格式
          if (result.code === 200 && result.data) {
            // 将对象转换为数组
            const provinces = Object.values(result.data).map(province => ({
              id: province.id,
              name: province.name,
              level: province.level,
              pid: province.pid,
              city: Object.values(province.city || {}).map(city => ({
                id: city.id,
                name: city.name,
                level: city.level,
                pid: city.pid
              }))
            }))
            resolve(provinces)
          } else {
            console.error('Unexpected API response format:', result.data)
            resolve([])
          }
        })
        .catch(err => {
          console.error('Region API Error:', err)
          reject(err)
        })
    })
  },
  getTreeData() {
    return new Promise((resolve, reject) => {
      const cached = localStorage.getItem(REGION_TREE)
      let data = cached ? JSON.parse(cached) : null
      const now = Date.now()
      if (data && data.timestamp && now - data.timestamp < 1 * 24 * 60 * 60 * 1000) {
        //console.log('Using cached region data:', data.list) // 调试日志
        resolve(Array.isArray(data.list) ? data.list : [])
      } else {
        this.getTreeDataFromApi()
          .then(list => {
            localStorage.setItem(REGION_TREE, JSON.stringify({ list, timestamp: now }))
            resolve(list)
          })
          .catch(err => reject(err))
      }
    })
  },
  getCitysCount() {
    return new Promise((resolve, reject) => {
      this.getTreeData()
        .then(data => {
          let count = 0
          if (!Array.isArray(data)) {
            console.error('Region data is not an array:', data)
            resolve(0)
            return
          }
          for (const province of data) {
            if (Array.isArray(province.city)) {
              count += province.city.length
            }
          }
          //console.log('City count:', count) // 调试日志
          resolve(count)
        })
        .catch(err => {
          console.error('Error fetching region data:', err)
          reject(err)
        })
    })
  }
}